import Modal from 'Common/Components/Modal';
import ButtonBase from 'components/ui/buttons/ButtonBase';
import React, { FC } from 'react';

type IProps = {
    show: boolean;
    handleClose: () => void;
    onConfirm: () => void;
    title?: string;
    message?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    showCancel?: boolean;
    id?: string | number;
    isLoading?: boolean;
};

const ConfirmationModal: FC<IProps> = ({
    show,
    handleClose,
    onConfirm,
    title = 'Confirmation',
    message = 'Are you sure you want to proceed?',
    confirmButtonText = 'Confirm',
    cancelButtonText = 'Cancel',
    showCancel = true,
    id,
    isLoading = false,
}) => {
    const handleConfirm = () => {
        onConfirm();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="mx-auto w-full max-w-lg p-3 shadow"
            backdropClassName="backdrop-overlay fixed inset-0 bg-slate-900/70 dark:bg-zink-900/85"
        >
            <Modal.Header>
                <Modal.Title className="text-lg font-semibold">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="my-5">
                <section className="flex flex-col gap-5">
                    <p className="text-gray-700">{message}</p>
                </section>
            </Modal.Body>
            <Modal.Footer className="flex items-center justify-center gap-2 mt-5">
                {showCancel && (
                    <ButtonBase
                        innerText={cancelButtonText}
                        className="bg-gray-500 hover:bg-gray-600 rounded border-none px-4 py-2 text-white"
                        onClick={handleClose}
                        disabled={isLoading}
                    />
                )}
                <ButtonBase
                    innerText={confirmButtonText}
                    className="bg-yellow-600 hover:bg-yellow-800 rounded border-none px-4 py-2 text-white disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={handleConfirm}
                    disabled={isLoading}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
